// Navigation seam for custom-scheme launches (google-chrome:// etc).
// jsdom's window.location is non-configurable, so a bare
// `window.location.href = …` cannot be spied in tests — which left the
// "launches Chrome" half of the combined copy-and-open action unverifiable
// (review finding). Launches route through this module boundary instead.
export function launchExternalUrl(href) {
  if (typeof window === "undefined" || !window.location || !href) return;
  window.location.assign(href);
}
